import React, { useState } from 'react';
import { Settings as SettingsIcon, Building2, Users } from 'lucide-react';
import { AgencySettings } from './sections/AgencySettings';
import { AgencyCommercials } from './sections/AgencyCommercials';
import { AdminDashboard } from '../../components/admin/AdminDashboard';
import { useAuth } from '../../contexts/AuthContext';
import { cn } from '../../lib/utils';

type SettingsTab = 'identity' | 'commercials';

export const SettingsPage: React.FC = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState<SettingsTab>('identity');

  // Si l'utilisateur est un admin, afficher l'interface de gestion des agences
  if (user?.role === 'admin') {
    return <AdminDashboard />;
  }

  const tabs = [
    {
      id: 'identity' as const,
      label: 'Identité de l\'agence',
      icon: Building2,
    },
    {
      id: 'commercials' as const,
      label: 'Commerciaux',
      icon: Users,
    },
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8 flex items-center gap-3">
        <SettingsIcon className="h-8 w-8 text-primary-500" />
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          Paramètres de l'agence
        </h1>
      </div>

      <div className="rounded-lg bg-white shadow-sm dark:bg-gray-800">
        {/* Navigation par onglets */}
        <div className="border-b border-gray-200 dark:border-gray-700">
          <nav className="flex space-x-8 px-6" aria-label="Tabs">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={cn(
                    'group inline-flex items-center gap-2 border-b-2 px-1 py-4 text-sm font-medium',
                    activeTab === tab.id
                      ? 'border-primary-500 text-primary-500'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
                  )}
                >
                  <Icon className="h-5 w-5" />
                  {tab.label}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Contenu des onglets */}
        <div className="p-6">
          {activeTab === 'identity' && <AgencySettings />}
          {activeTab === 'commercials' && <AgencyCommercials />}
        </div>
      </div>
    </div>
  );
};
